// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Y726","file":"styles_file__L0AxL"};